/*
 * Required-field validation for the product customization form
 * (snippets/product-custom-form.liquid).
 *
 * The product form is rendered with `novalidate`, so the browser never enforces
 * `required`. This listens in the CAPTURE phase on the ancestor <product-form>,
 * which runs before the <form>'s own submit listener in product-form.js — the
 * only place from which the add-to-cart fetch can still be cancelled.
 */
if (!customElements.get('product-custom-form')) {
  customElements.define(
    'product-custom-form',
    class ProductCustomForm extends HTMLElement {
      connectedCallback() {
        if (this.scope) return;
        // The block renders as a sibling of the product form, not inside it, so the
        // <product-form> ancestor is reached through the form id rather than closest().
        const form = document.getElementById(this.dataset.formId);
        this.scope = form && form.closest('product-form');
        if (!this.scope) return;

        this.onSubmit = this.onSubmit.bind(this);
        this.scope.addEventListener('submit', this.onSubmit, true);
        this.addEventListener('input', this.onInput);
      }

      disconnectedCallback() {
        if (!this.scope) return;
        this.scope.removeEventListener('submit', this.onSubmit, true);
        this.scope = null;
      }

      get emptyRequiredFields() {
        return Array.from(this.querySelectorAll('[required]')).filter((field) => !field.value.trim());
      }

      onSubmit(event) {
        const invalid = this.emptyRequiredFields;
        this.classList.toggle('pcf--invalid', invalid.length > 0);
        if (invalid.length === 0) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        invalid.forEach((field) => field.setAttribute('aria-invalid', 'true'));

        // A field inside a closed <details> cannot be focused — open it first.
        const group = invalid[0].closest('details');
        if (group) group.open = true;
        invalid[0].focus();
      }

      onInput(event) {
        const field = event.target;
        if (!field.hasAttribute('required') || !field.value.trim()) return;
        field.removeAttribute('aria-invalid');
        if (this.emptyRequiredFields.length === 0) this.classList.remove('pcf--invalid');
      }
    }
  );
}
